import { useEffect, useContext } from "react";
import {
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import 'antd/dist/antd.css';
import {
  DesktopOutlined,
  TeamOutlined,
  SettingOutlined,
} from '@ant-design/icons';

import Login from "./Pages/Login";
import Accounts from "./Pages/Accounts";
import SideMenu from "./Components/SideMenu";
import Orders from "./Pages/Orders";
import SubmitOrder from './Pages/NewOrder';
import Config from './Pages/Config';
import './App.css';
import './Services/firebase/firebaseConfig';
import { getCurrentUser } from './Services/firebase/auth';
import { AuthContext } from './Context/AuthContext';

const routes = [
  {
    name: "Login",
    path: "/login",
    type: "NotRequireAuth",
    element: <Login />,
    icon: <DesktopOutlined />,
  },
  {
    name: "New Order",
    path: "/",
    type: "RequireAuth",
    element: <SubmitOrder />,
    icon: <DesktopOutlined />,
  },
  {
    name: "Orders",
    path: "/orders",
    type: "RequireAuth",
    element: <Orders />,
    icon: <DesktopOutlined />,
  },
  {
    name: "Accounts",
    path: "/accounts",
    type: "RequireAuth",
    element: <Accounts />,
    icon: <TeamOutlined />,
  },
  {
    name: "Setting",
    path: "/setting",
    type: "RequireAuth",
    element: <Config />,
    icon: <SettingOutlined />,
  }
]

const App = () => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    const auth = localStorage.getItem("user");
    if (auth && authContext) {
      getCurrentUser(user => {
        authContext.setAuthUser(user);
      });
    }
  }, [authContext]);

  const unprotectedRoutes = routes.filter(item => item.type === "NotRequireAuth");
  const protectedRoutes = routes.filter(item => item.type === "RequireAuth");

  return (
    <Routes>
      {unprotectedRoutes.map(item => (
        <Route
          path={item.path}
          element={
            <CheckAuth>
              {item.element}
            </CheckAuth>
          }
        />
      ))}

      <Route element={<SideMenu routes={protectedRoutes} />}>
        {protectedRoutes.map(item => (
          <Route
            path={item.path}
            element={
              <RequireAuth>
                {item.element}
              </RequireAuth>
            }
          />
        ))}
      </Route>
    </Routes >
  );
}

const CheckAuth = ({ children }) => {
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const auth = localStorage.getItem("user");
  if (auth) {
    return <Navigate to={from} replace />;
  }

  return children;
}

const RequireAuth = ({ children }) => {
  const auth = localStorage.getItem("user");
  let location = useLocation();

  if (!auth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default App;
